import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public router: Router, private authenService: AuthenticationService) { }

  ngOnInit() {

    if (!this.authenService.isAuthenticated()) {
      this.router.navigate(['/login']);
    }
  }
  goto(route){
    if (route){
      this.router.navigate([route]);
    }
  }

}
